import { Link } from "react-router-dom";
import { CardHeader } from "reactstrap";

const CardHeaderLayout = ({ title, url, button }) => {
  return (
    <CardHeader>
      {title ? (
        <>
          <h5>{title}</h5>
          <span>{title}</span>
        </>
      ) : null}
      <div className="text-end">
        {url ? <Link to={url}>{button}</Link> : button}
      </div>
    </CardHeader>
  );
};

export default CardHeaderLayout;
